<template>
  <v-data-table :items="payments" :headers="invoiceHeaders" hide-default-footer disable-sort>
    <template v-slot:item.appointment_code="{ item }">
      <a v-if="item.appointment" :href="`/admin-appointment/${item.appointment.id}`" target="_blank">
        {{ item.appointment.code }}
      </a>
      <span v-else>---</span>
    </template>
    <template v-slot:item.created_at="{ item }">
      {{ formatDate(item.created_at) }}
    </template>
    <template v-slot:item.description="{ item }">
      {{ description(item.description) }}
    </template>
    <template v-slot:item.payment_type="{ item }">
      {{ paymentType(item) }}
    </template>
    <template v-slot:item.total="{ item }">
      {{ formatMoney(item.total) }}
    </template>
  </v-data-table>
</template>

<script>
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { invoiceHeaders } from '../../adminInvoiceHeaders'

export default {
  name: 'PaymentList',

  props: {
    payments: {
      type: Array,
      required: false,
    },
  },

  methods: {
    paymentType(item) {
      return item.payment_type ? this.$t(`transfer.transferStatus.${item.payment_type}`) : '---'
    },

    description(description) {
      return description ?? '---'
    },
  },

  data() {
    return {
      invoiceHeaders,
      formatMoney: catalogMonetary,
      formatDate: catalogDate,
    }
  }
}
</script>
